<template>
    <div class="vActivityList">
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="!dataList.length"></NoData>
            <div class="m-list" v-else>
                <div class="box" v-for="(obj) in dataList" :key="obj.courseid" @click="gotoView(obj)">
                    <img class="coverurl" :src="obj.eventlogo" alt="">
                    <div class="subject blod">{{obj.title}}</div>
                    <div class="info">
                        <div class="tc-grey">{{obj.begintime}} - {{obj.endtime}}</div>
                        <div class="tc-grey">{{obj.areaname}}</div>
                    </div>
                </div>
            </div>
        </Pull>
    </div>
</template>

<script>
  import Pull from 'views/mobile/components/pull/pull'
  import {getEventByHost} from 'api/activeTools'
  import {mapActions, mapGetters} from 'vuex'
  import NoData from 'views/mobile/components/noData/noData'
  export default {
    name: 'vActivityList',
    data() {
      return {
        param: {
          hostid: this.$route.query.hostid ? this.$route.query.hostid : '',
          seetype: 1  // 查看类型 1 全部活动 2 进行中活动
        },
        dataList: [],
        page: {
          page: 1,
          pageSize: 10,
          pageCount: 2,
          rowCount: 0
        },
        pull: {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        },
      }
    },
    props: ['item'],
    mounted() {
      this.setNoDataTip('当前暂无内容')
    },
    methods: {
      gotoView(obj) {
        if (obj.enrolleventsource == 1) {
          this.setRefresh(true)
          this.$router.push({name: 'ActivityDetail', query: {eventid: obj.eventid}})
        } else {
          window.location.href = obj.enrolllinkurl
        }
      },
      initList() {
        this.param.hostid = this.$route.query.hostid ? this.$route.query.hostid : ''
        this.getList()
      },
      getList() {
        this.setLoading(true)
        getEventByHost({
          data: Object.assign({}, this.param, this.page),
          success: data => {
            if (this.page.page === 1) {
              this.pull.isLoading = false
              this.dataList = data.data.content
            } else {
              this.dataList = this.dataList.concat(data.data.content)
            }
            this.setLoading(false)
            this.pull.loading = false
            this.page.pageCount = data.data.pageinfo.pageCount
            this.page.rowCount = data.data.pageinfo.rowCount
            if (this.page.page === this.page.pageCount) {
              this.pull.finished = true
            }
          },
          error: data => {
            this.setLoading(false)
            this.pull.error = true
            this.pull.loading = false
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setRefresh', 'setNoDataTip'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['refresh'])
    },
    components: {
      Pull, NoData
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    .vActivityList {
       .box{
           height: 3.8rem;
           box-shadow:0 0 0.1rem 0 rgba(0,0,0,0.2);
           border-radius:0.06rem;
           overflow: hidden;
           .subject{
               padding: 0 0.08rem;
               box-sizing: border-box;
           }
           .info{
               font-size: 0.2rem;
               margin-top: 0.12rem;
               line-height: 0.28rem;
               padding: 0 0.08rem;
               box-sizing: border-box;
               div+div{
                   margin-top: 0.08rem;
               }
           }
       }
    }
</style>